// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1HW2S","col":"styles_col__2hpkf","fulfillmentStatus":"styles_fulfillmentStatus__2QGpy","emailCol":"styles_emailCol__3H_IF"};